exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fast-contact-section {\n\tpadding-top : 30px;\n\tpadding-bottom : 30px;\n\tcolor : #fff;\n\tmargin: auto;\n\tdisplay: flex;\n}\n\n@media only screen and (max-width: 600px) {\n\t.fast-contact-section {\n\t\tdisplay: block;\n\t}\n\n\t.fast-contact-section .button{\n\t\tmargin-top: 30px;\n\t}\n}", ""]);

